import { createRequest, RequestConfig } from 'app/common/api';

import { TTariffProfile } from '../core/tariff-profile';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_tariff_profile',
};

export const updateTariffProfileRequest = (tariffProfile: TTariffProfile) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(tariffProfile),
  });
